import Swiper, { Autoplay } from 'swiper';
Swiper.use([ Autoplay ]);

export default () => {
    let container = document.querySelector('.front-page-opinions-right-boxes__slider');

    if (container) {
        let opinionsSlider = slider(container);
        sliderArrows(opinionsSlider);

        window.addEventListener('resize', () => {
            sliderArrows(opinionsSlider);
        });
    }
}

let slider = (container) => {
    let swiper = new Swiper(container, {
        observer: true,
        observeParents: true,
        loop: true,
        slidesPerView: 2,
        spaceBetween: 20,
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
        breakpoints: {
            993: {
                slidesPerView: 3
            },
        }
    });

    /*swiper.on('slideChange', (swiper) => {
        console.log(swiper.activeIndex);
        console.log(swiper.slides.length);
        if (swiper.activeIndex + 3 === swiper.slides.length) {
            container.classList.add('moved');
        } else {
            container.classList.remove('moved');
        }
    });*/

    return swiper;
}

let sliderArrows = (swiper) => {
    let prev = document.querySelector('.front-page-opinions-right-arrows__left');
    let next = document.querySelector('.front-page-opinions-right-arrows__right');

    let updateArrows = () => {
        let wrapper = document.querySelector('.front-page-opinions-right-boxes__slider .swiper-wrapper');
        let nodes = Array.prototype.slice.call( wrapper.querySelectorAll('.swiper-slide') );
        let liRef = wrapper.querySelectorAll('.swiper-slide-active')[0];
        let index = nodes.indexOf(liRef);

        if (index === 0) {
            prev.classList.add('disabled');
        }
        else {
            prev.classList.remove('disabled');
        }

        if (index === (nodes.length - 3)) {
            next.classList.add('disabled');
        }
        else {
            next.classList.remove('disabled');
        }
    };

    prev.addEventListener('click', function () {
        swiper.slidePrev(500, false);
    })

    next.addEventListener('click', function () {
        swiper.slideNext(500, false);
    })

    /*updateArrows();

    swiper.on('slideChange', () => {
        setTimeout(function(){
            updateArrows();
        });
    });*/
}
